import { wait } from "./delay";

export const simulateTyping = async (setIsTyping, d, factor = 4) => {
  setIsTyping(true);
  await wait(d * factor);
  setIsTyping(false);
};

export const display = (setMessages, msg, delay = 0, isUser = false) =>
  wait(delay).then(() =>
    setMessages((m) => [
      ...m,
      {
        ...msg,
        isUser,
        timestamp: new Date().toISOString(),
      },
    ])
  );

export const getRandomFromArray = (arr) =>
  arr[Math.floor(Math.random() * arr.length)];

export const photoResponses = [
  "Voici une photo spéciale pour toi 💕",
  "Je t'envoie une photo, dis-moi ce que tu en penses…",
  "Celle-ci est pour tes beaux yeux 😘",
  "Tu veux une photo ? En voilà une…",
  "J'espère qu'elle va te plaire…",
  "Une photo rien que pour toi…",
  "Regarde ce que j'ai retrouvé dans ma galerie… 😏",
  "Je partage ça juste avec toi…"
]; 